/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPageResVo
 */
export interface UserPageResVo {
    /**
     * 用户id
     * @type {number}
     * @memberof UserPageResVo
     */
    id?: number;
    /**
     * 登录账号
     * @type {string}
     * @memberof UserPageResVo
     */
    account?: string;
    /**
     * 用户姓名
     * @type {string}
     * @memberof UserPageResVo
     */
    name?: string;
    /**
     * 电话号码
     * @type {string}
     * @memberof UserPageResVo
     */
    mobileNo?: string;
    /**
     * 用户编号
     * @type {string}
     * @memberof UserPageResVo
     */
    code?: string;
    /**
     * 级别名称
     * @type {string}
     * @memberof UserPageResVo
     */
    gradeName?: string;
    /**
     * 客户商业类型  1 企业 2 个人
     * @type {string}
     * @memberof UserPageResVo
     */
    businessTypeName?: string;
    /**
     * 商户名称
     * @type {string}
     * @memberof UserPageResVo
     */
    companyName?: string;
    /**
     * 专属客服姓名
     * @type {string}
     * @memberof UserPageResVo
     */
    customerServiceStaffName?: string;
    /**
     * 钱包货币名称
     * @type {string}
     * @memberof UserPageResVo
     */
    walletCurrencyName?: string;
    /**
     * 是否开发票
     * @type {string}
     * @memberof UserPageResVo
     */
    vatString?: string;
    /**
     * 钱包余额
     * @type {string}
     * @memberof UserPageResVo
     */
    walletBalance?: string;
    /**
     * 韩国钱包预存款余额
     * @type {string}
     * @memberof UserPageResVo
     */
    koreaWalletBalance?: string;
    /**
     * 中国钱包预存款余额
     * @type {string}
     * @memberof UserPageResVo
     */
    chinaWalletBalance?: string;
    /**
     * 透支额度
     * @type {string}
     * @memberof UserPageResVo
     */
    overdraftLimit?: string;
    /**
     * 韩国钱包透支额度
     * @type {string}
     * @memberof UserPageResVo
     */
    koreaOverdraftLimit?: string;
    /**
     * 中国钱包透支额度
     * @type {string}
     * @memberof UserPageResVo
     */
    chinaOverdraftLimit?: string;
    /**
     * 推荐人编号
     * @type {string}
     * @memberof UserPageResVo
     */
    recommendCode?: string;
    /**
     * 用户状态
     * @type {string}
     * @memberof UserPageResVo
     */
    userStatus?: string;
    /**
     * 最后登录时间
     * @type {string}
     * @memberof UserPageResVo
     */
    lastLoginTime?: string;
    /**
     * 注册时间
     * @type {string}
     * @memberof UserPageResVo
     */
    registerTime?: string;
}

/**
 * Check if a given object implements the UserPageResVo interface.
 */
export function instanceOfUserPageResVo(value: object): value is UserPageResVo {
    return true;
}

export function UserPageResVoFromJSON(json: any): UserPageResVo {
    return UserPageResVoFromJSONTyped(json, false);
}

export function UserPageResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPageResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account': json['account'] == null ? undefined : json['account'],
        'name': json['name'] == null ? undefined : json['name'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'code': json['code'] == null ? undefined : json['code'],
        'gradeName': json['gradeName'] == null ? undefined : json['gradeName'],
        'businessTypeName': json['businessTypeName'] == null ? undefined : json['businessTypeName'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'customerServiceStaffName': json['customerServiceStaffName'] == null ? undefined : json['customerServiceStaffName'],
        'walletCurrencyName': json['walletCurrencyName'] == null ? undefined : json['walletCurrencyName'],
        'vatString': json['vatString'] == null ? undefined : json['vatString'],
        'walletBalance': json['walletBalance'] == null ? undefined : json['walletBalance'],
        'koreaWalletBalance': json['koreaWalletBalance'] == null ? undefined : json['koreaWalletBalance'],
        'chinaWalletBalance': json['chinaWalletBalance'] == null ? undefined : json['chinaWalletBalance'],
        'overdraftLimit': json['overdraftLimit'] == null ? undefined : json['overdraftLimit'],
        'koreaOverdraftLimit': json['koreaOverdraftLimit'] == null ? undefined : json['koreaOverdraftLimit'],
        'chinaOverdraftLimit': json['chinaOverdraftLimit'] == null ? undefined : json['chinaOverdraftLimit'],
        'recommendCode': json['recommendCode'] == null ? undefined : json['recommendCode'],
        'userStatus': json['userStatus'] == null ? undefined : json['userStatus'],
        'lastLoginTime': json['lastLoginTime'] == null ? undefined : json['lastLoginTime'],
        'registerTime': json['registerTime'] == null ? undefined : json['registerTime'],
    };
}

export function UserPageResVoToJSON(json: any): UserPageResVo {
    return UserPageResVoToJSONTyped(json, false);
}

export function UserPageResVoToJSONTyped(value?: UserPageResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account': value['account'],
        'name': value['name'],
        'mobileNo': value['mobileNo'],
        'code': value['code'],
        'gradeName': value['gradeName'],
        'businessTypeName': value['businessTypeName'],
        'companyName': value['companyName'],
        'customerServiceStaffName': value['customerServiceStaffName'],
        'walletCurrencyName': value['walletCurrencyName'],
        'vatString': value['vatString'],
        'walletBalance': value['walletBalance'],
        'koreaWalletBalance': value['koreaWalletBalance'],
        'chinaWalletBalance': value['chinaWalletBalance'],
        'overdraftLimit': value['overdraftLimit'],
        'koreaOverdraftLimit': value['koreaOverdraftLimit'],
        'chinaOverdraftLimit': value['chinaOverdraftLimit'],
        'recommendCode': value['recommendCode'],
        'userStatus': value['userStatus'],
        'lastLoginTime': value['lastLoginTime'],
        'registerTime': value['registerTime'],
    };
}

